import styled, { css } from 'styled-components';

import { IRefreshAltProps } from '.';

export const Container = styled.button<IRefreshAltProps>`
  ${({ theme, marginTop, marginLeft }) => css`
    background-color: transparent;
    color: ${theme.colors.refresh};
    padding: 8px;
    border-radius: 50%;
    box-shadow: 1px 1px 1px ${theme.colors.lightGrey};

    &:hover {
      transform: scale(1.2, 1.2);
    }

    ${marginTop &&
    css`
      margin-top: ${marginTop};
    `}

    ${marginLeft &&
    css`
      margin-left: ${marginLeft};
    `}
  `}
`;
